/* eslint-disable max-len */

import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';

import AutoMsgDetails from 'clientCommunications/components/Automate/AutoMsgDetails';

const AutoMessages = ({ showContent, sortFunction, autoSmsByMonth, groupOrderChanged }) => {
  const [detailsMonth, setDetailsMonth] = useState('');
  const [detailsBucket, setDetailsBucket] = useState('');
  const [data, setData] = useState([]);

  const { t } = useTranslation();

  const resetIsCollapsed = (tf) => {
    if (autoSmsByMonth && detailsMonth) {
      for (let i = 0; i < autoSmsByMonth.length; i += 1) {
        if (autoSmsByMonth[i][0] === detailsMonth) {
          for (let j = 0; j < autoSmsByMonth[i][1].length; j += 1) {
            if (autoSmsByMonth[i][1][j].isCollapsed === false) {
              // eslint-disable-next-line no-param-reassign
              autoSmsByMonth[i][1][j].isCollapsed = tf;
            }
          }
        }
      }
    }
  };

  const showDetails = (item) => {
    if (detailsMonth !== item) {
      setDetailsMonth(item);
    } else {
      setDetailsMonth('');
    }
  };
  const showDetailsBucket = (bucket) => {
    if (detailsBucket !== bucket) {
      setDetailsBucket(bucket);
      resetIsCollapsed(null);
    } else {
      setDetailsBucket('');
    }
  };

  useEffect(() => {
    if (autoSmsByMonth) {
      setData(autoSmsByMonth);
    }
  }, [autoSmsByMonth, groupOrderChanged]);

  return (
    <div>
      <table className="tbl-automsg-results">
        <tbody>
          {data.map(([item, value]) => {
            let clientsForMonthSize = 0;
            if (value && Array.isArray(value)) {
              clientsForMonthSize = value.reduce(
                (totalClient, message) => totalClient + parseInt(message.unique_recipients_count, 10),
                0,
              );
            }

            const groupByBucketType = groupBy(value, 'bucket');
            const calcSmsSent = () => {
              let sum = 0;
              if (Array.isArray(value)) {
                sum = value.reduce((sms, e) => sms + e.sms_count, 0);
              }
              return sum;
            };
            const calcBookings = () => {
              let sum = 0;
              if (Array.isArray(value)) {
                sum = value.reduce((sms, e) => sms + e.appointments_count, 0);
              }
              return sum;
            };
            const calcRevenue = () => {
              let sum = 0;
              if (Array.isArray(value)) {
                sum = value.reduce((sms, e) => sms + e.revenue, 0);
              }
              return sum.toFixed(2);
            };
            const calcSmsCost = () => {
              let sum = 0;
              if (Array.isArray(value)) {
                sum = value.reduce((sms, e) => sms + e.cost, 0);
              }
              return sum.toFixed(2);
            };

            return (
              <tr className="tbl-row" key={item}>
                <td className="">
                  <table className={`tbl-inner-result ${detailsMonth !== item ? '' : 'opened'}`}>
                    <tbody>
                      <tr>
                        <td colSpan="5">
                          <div className={`visible-content ${detailsMonth !== item ? '' : 'opened'}`}>
                            <table className="tbl-single-row">
                              <tbody>
                                <tr className="big-font">
                                  <td className="date-width">
                                    <div
                                      onClick={() => {
                                        showDetails(item);
                                      }}
                                      role="button"
                                      tabIndex="0"
                                    >
                                      <div className="yy-mm">
                                        <span>{item}</span>
                                        <span>
                                          {detailsMonth !== item
                                            ? t('campaigns.tableRows.viewMsg')
                                            : t('campaigns.tableRows.hideMsg')}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="target-width">{t('campaigns.tableRows.allSentMsg')}</td>
                                  <td className="message-width">
                                    <span className="f-28">{clientsForMonthSize}</span>
                                    <span className="d-block">{t('campaigns.tableRows.clients')}</span>
                                  </td>
                                  <td className="sms-sent-width">
                                    <span className="f-28">{calcSmsSent()}</span>
                                  </td>
                                  <td className="booking-width">
                                    <span className="f-28">{calcBookings()}</span>
                                  </td>
                                  <td className="revenue-width">
                                    <span className="f-28">
                                      <CurrencySign />
                                      {calcRevenue()}
                                    </span>
                                  </td>
                                  <td className="sms-cost-width 1">
                                    <span className="f-28">
                                      <CurrencySign />
                                      {calcSmsCost()}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          {detailsMonth === item &&
                            Object.entries(groupByBucketType).map(([bucket, valueBucket]) => {
                              const calcClientsInBucket = () => {
                                let unicClient = 0;
                                if (Array.isArray(valueBucket)) {
                                  unicClient = valueBucket.reduce((sms, e) => sms + e.unique_recipients_count, 0);
                                }
                                return unicClient;
                              };
                              const calcSmsSentBucket = () => {
                                let sum = 0;
                                if (Array.isArray(valueBucket)) {
                                  sum = valueBucket.reduce((sms, e) => sms + e.sms_count, 0);
                                }
                                return sum;
                              };
                              const calcBookingsBucket = () => {
                                let sum = 0;
                                if (Array.isArray(valueBucket)) {
                                  sum = valueBucket.reduce((sms, e) => sms + e.appointments_count, 0);
                                }
                                return sum;
                              };
                              const calcRevenueBucket = () => {
                                let sum = 0;
                                if (Array.isArray(valueBucket)) {
                                  sum = valueBucket.reduce((sms, e) => sms + e.revenue, 0);
                                }
                                return sum.toFixed(2);
                              };
                              const calcSmsCostBucket = () => {
                                let sum = 0;
                                if (Array.isArray(valueBucket)) {
                                  sum = valueBucket.reduce((sms, e) => sms + e.cost, 0);
                                }
                                return sum.toFixed(2);
                              };
                              return (
                                <div className="bucket-by-type" key={bucket}>
                                  <table className="tbl-single-row">
                                    <tbody>
                                      <tr className="big-font">
                                        <td className="date-width">
                                          <div onClick={() => showDetailsBucket(bucket)} role="button" tabIndex="0">
                                            <div className="btn btn-link">
                                              <span>
                                                {detailsBucket !== bucket
                                                  ? t('campaigns.tableRows.viewMsg')
                                                  : t('campaigns.tableRows.hideMsg')}
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                        <td className="target-width">
                                          <span style={{ display: 'block' }}>
                                            {bucket === 'thanks' && (
                                              <div>{t('campaigns.tableRows.clientReviewPrompt')}</div>
                                            )}
                                            {bucket === 'thanks_new' && (
                                              <div>{t('campaigns.tableRows.newClientReviewPrompt')}</div>
                                            )}
                                            {bucket === 'birthday' && (
                                              <div>{t('campaigns.tableRows.birthdayClientPrompt')}</div>
                                            )}
                                            {bucket === 'lapsed' && (
                                              <div>{t('campaigns.tableRows.clientRetentionPrompt')}</div>
                                            )}
                                            {bucket === 'prompt_rebook' && (
                                              <div>{t('campaigns.tableRows.clientRebookPrompt')}</div>
                                            )}
                                          </span>
                                        </td>
                                        <td className="message-width">
                                          <span className="d-inline">
                                            {calcClientsInBucket()} {t('campaigns.tableRows.clients')}
                                          </span>
                                        </td>
                                        <td className="sms-sent-width">
                                          <span className="f-28">{calcSmsSentBucket()}</span>
                                        </td>
                                        <td className="booking-width">
                                          <span className="f-28">{calcBookingsBucket()}</span>
                                        </td>
                                        <td className="revenue-width">
                                          <span className="f-28">
                                            <CurrencySign />
                                            {calcRevenueBucket()}
                                          </span>
                                        </td>
                                        <td className="sms-cost-width 1">
                                          <span className="f-28">
                                            <CurrencySign />
                                            {calcSmsCostBucket()}
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {detailsBucket === bucket && (
                                    <div>
                                      {groupByBucketType[bucket].map((message) => (
                                        <AutoMsgDetails
                                          message={message}
                                          showContent={showContent}
                                          sortFunction={sortFunction}
                                        />
                                      ))}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AutoMessages;
